/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export enum LoggedOutRoutes {
  home = '/',
  sso_success_route = '/login-sso',
  sso_init_route = '/sso/spinitsso-redirect',
  unknown_user = '/unknown-user',
}

export const authenticatedAppRoutes = {
  profile: (employeeId = ':id', resigned?: boolean) => `/profile/${employeeId}${resigned ? '/resigned' : ''}`,
  searchResults: () => '/search-results',
}
